// src/components/Services.jsx
import React, { useMemo, useState } from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Services.scss";

import hamburguesas from "../images/banquetes/hamburguesas.jpg";
import italiano from "../images/banquetes/italiano.jpg";
import cortes from "../images/banquetes/cortes.jpg";
import tacos from "../images/banquetes/tacos.jpg";
import texas from "../images/banquetes/texas.jpg";
import extras from "../images/banquetes/extras.jpg";

// ✅ Usa 1 SOLO número para TODO el sitio (mismo que en tus otros componentes)
const WHATS_NUMBER = "523345851702";

const Services = () => {
  const [selected, setSelected] = useState(null);

  const services = useMemo(
    () => [
      {
        id: "hamburguesas",
        title: "Hamburguesas al Carbón",
        short:
          "Hamburguesas premium al carbón con guarnición a elegir. Ideal para eventos residenciales y empresariales.",
        badge: "Más pedido",
        image: hamburguesas,
        modalTitle: "Hamburguesas al Carbón",
        blocks: [
          {
            heading: "Elige la que más te guste",
            type: "numbered",
            items: [
              "“De la casa” manchego gratinado y pan artesanal aderezado con nuestra mayonesa de chile güero y una cama de mermelada piña tocino.",
              "“La Selena” bañada con salsa BBQ Honey crujiente de aros de cebolla y queso cheddar.",
              "“Tres quesina” gratinada con manchego, gouda y parmesano, mayonesa casera de chile güero y arúgula crujiente.",
              "“Guerra azteca” queso Oaxaca y panela gratinada, tocino crujiente y mayonesa de aguacate.",
              "“La Fit Fat” láminas de portobello gratinadas con queso manchego y gouda sobre cama de arúgula crujiente y pesto de perejil con romero.",
            ],
          },
          {
            heading: "Guarnición (escoge una opción)",
            type: "bullets",
            items: [
              "Papas a la francesa",
              "Papas gajo",
              "Papas cambray rostizadas al romero",
              "Mac & Cheese (macarrones con queso)",
            ],
          },
          {
            heading: "Acompañado de",
            type: "text",
            text: "Catsup, mostaza, pepinillos y jalapeños.",
          },
          {
            heading: "Precio por persona",
            type: "bullets",
            items: [
              "20 a 29 personas — $295 p/p",
              "30 a 39 personas — $285 p/p",
              "40 a 49 personas — $275 p/p",
              "50 o más personas — $265 p/p",
            ],
          },
        ],
      },
      {
        id: "italiano",
        title: "Buffet Italiano",
        short:
          "Arma la pasta a tu gusto (3 pastas + 3 salsas) e incluye 2 carnes. Perfecto para eventos familiares o corporativos.",
        badge: "Elegante",
        image: italiano,
        modalTitle: "Buffet Italiano",
        blocks: [
          {
            heading: "Arma la pasta a tu gusto",
            type: "text",
            text: "Elegir 3 pastas y 3 salsas.",
          },
          {
            heading: "Pastas",
            type: "numbered",
            items: ["Fetuccini", "Espagueti", "Fusilli", "Pluma"],
          },
          {
            heading: "Salsas",
            type: "numbered",
            items: [
              "Salsa Alfredo",
              "Al burro (mantequilla y pimienta)",
              "Tres quesos",
              "Primavera (verduras a la mantequilla)",
              "Apio tocino",
              "Pomodoro",
              "Al pesto",
              "Carbonara",
              "Crema de champiñones",
            ],
          },
          {
            heading: "Extra",
            type: "text",
            text: "Agrega camarones a una pasta con costo de $20 pesos por persona.",
          },
          {
            heading: "Incluye dos (2) carnes",
            type: "numbered",
            items: [
              "Lomo en salsa de vino tinto",
              "Fajitas de pollo al cilantro",
              "Puntas de res con champiñones",
              "Fajitas de arrachera",
              "Lomo en salsa de champiñones",
              "Punta de res en salsa de tres quesos",
              "Lasaña boloñesa o de espinacas",
            ],
          },
          {
            heading: "Acompañamientos",
            type: "text",
            text: "Ensalada fresca con frutos y aderezo mostaza miel.",
          },
          {
            heading: "Precio por persona",
            type: "bullets",
            items: [
              "30 a 39 personas — $235 p/p",
              "40 a 49 personas — $225 p/p",
              "50 a 99 personas — $195 p/p",
              "100 o más — $175 p/p",
            ],
          },
        ],
      },
      {
        id: "cortes",
        title: "Buffet Cortes al Carbón",
        short:
          "Cortes premium servidos al centro de la mesa con entradas y guarniciones. Experiencia tipo parrillada.",
        badge: "Premium",
        image: cortes,
        modalTitle: "Buffet Cortes al Carbón",
        blocks: [
          {
            heading: "Carnes",
            type: "text",
            text: "Picaña, Rib Eye, arrachera y chistorra (los cortes se sirven en fajitas sobre base de madera para que puedan probar todas las carnes).",
          },
          {
            heading: "Entradas (incluye 1 servida al centro)",
            type: "numbered",
            items: [
              "Espárragos al grill con jamón serrano y queso parmesano",
              "Tuétanos al grill",
              "Queso fundido con champiñones",
              "Panela al pesto",
            ],
          },
          {
            heading: "Entradas (incluye 1 entrada individual)",
            type: "numbered",
            items: [
              "Empanada argentina de carne",
              "Morrón relleno de queso gouda, tocino y champiñones",
              "Portobelo relleno de gouda y manchego con ensalada de arúgula y cherry",
            ],
          },
          {
            heading: "Acompañamientos (incluye 3)",
            type: "numbered",
            items: [
              "Papas cambray rostizadas al romero",
              "Puré rústico de papa y camote",
              "Elote amarillo en crema mantequilla y pimienta",
              "Ensalada fresca de la casa aderezo mostaza miel",
              "Verduras al grill",
              "Fetuccini en salsa tres quesos (ideal si hay niños)",
            ],
          },
          {
            heading: "Precio por persona",
            type: "bullets",
            items: [
              "20 a 29 personas — $415 p/p",
              "30 a 39 personas — $405 p/p",
              "40 a 49 personas — $395 p/p",
              "50 o más — $385 p/p",
            ],
          },
        ],
      },
      {
        id: "tacos",
        title: "Buffet Tacos al Carbón",
        short:
          "Tacos al carbón con carnes y guarniciones clásicas. Excelente para eventos grandes y ambiente casual.",
        badge: "Ideal eventos",
        image: tacos,
        modalTitle: "Buffet Tacos al Carbón",
        blocks: [
          {
            heading: "Carnes",
            type: "bullets",
            items: ["Picaña", "Adobada", "Arrachera", "Chorizo"],
          },
          {
            heading: "Guarniciones",
            type: "bullets",
            items: [
              "Elote amarillo con crema de mantequilla y pimienta",
              "Verduras al grill",
              "Quesadillas de maíz",
              "Papas cambray rostizadas al romero",
              "Nopalitos",
              "Frijoles de la olla",
            ],
          },
          {
            heading: "Acompañamientos",
            type: "bullets",
            items: [
              "Salsa de aguacate",
              "Salsa roja",
              "Chiles toreados",
              "Limones",
              "Tortillas de máquina",
            ],
          },
          {
            heading: "Nota",
            type: "text",
            text: "Puede cotizar servicio de tortera con costo extra de $500 (sujeto a disponibilidad).",
          },
          {
            heading: "Precios por persona",
            type: "bullets",
            items: [
              "30 a 39 personas — $255 p/p",
              "40 a 49 personas — $245 p/p",
              "50 a 99 personas — $235 p/p",
              "100 personas o más — $225 p/p",
            ],
          },
        ],
      },
      {
        id: "texas",
        title: "Buffet Texas BBQ",
        short:
          "Estilo BBQ con costilla honey y pollo cajún. Una opción potente para eventos empresariales y celebraciones.",
        badge: "BBQ",
        image: texas,
        modalTitle: "Buffet Texas BBQ",
        blocks: [
          {
            heading: "Carnes",
            type: "bullets",
            items: [
              "Costilla BBQ Honey",
              "Picaña",
              "Pollo cajún a las brazas (pierna y muslo)",
              "Chorizo",
            ],
          },
          {
            heading: "Guarniciones",
            type: "bullets",
            items: [
              "Elote amarillo con crema de mantequilla y pimienta",
              "Mac & Cheese (macarrones con queso cremoso)",
              "Ensalada de col y zanahoria con arándanos",
            ],
          },
          {
            heading: "Acompañamientos",
            type: "bullets",
            items: ["Pan", "Salsa roja", "Salsa BBQ picante", "Chiles en escabeche"],
          },
          {
            heading: "Precios por persona",
            type: "bullets",
            items: [
              "20 a 29 personas — $375 p/p",
              "30 a 39 personas — $365 p/p",
              "41 a 49 personas — $355 p/p",
              "50 a 99 personas — $345 p/p",
              "100 personas o más — $335 p/p",
            ],
          },
        ],
      },
      {
        id: "extras",
        title: "Menú de Extras",
        short:
          "Complementa tu banquete con entradas y extras al carbón. Perfecto para personalizar tu evento.",
        badge: "Extras",
        image: extras,
        modalTitle: "Menú de Extras",
        blocks: [
          {
            heading: "Extras disponibles",
            type: "bullets",
            items: [
              "Hamburguesa infantil — 120g de carne de res con queso americano y papas a la francesa — $125 p/p",
              "Empanada argentina — rellena de carne molida con pimientos o elote crema y queso — $39 p/p",
              "Queso fundido — mix de quesos con champiñones (sartén de hierro al centro) — $139 para 10 personas",
              "Morrones rellenos — queso manchego y gouda con champiñones y tocino — $39 p/p",
              "Portobelo relleno — queso manchego y gouda con ensalada arúgula, cherry y pesto — $39 p/p",
              "Chistorra — al centro para 10 personas — $195",
              "Brochetas — 2 por persona (picaña, morrón y cebolla) — $39 p/p",
              "Papas cambray al pesto — $120 para 10 personas",
              "Costilla de elote — $165 para 10 personas",
              "Tuétanos — $195 al centro para 5 personas",
              "Espárragos — al grill con queso parmesano y jamón serrano (al centro)",
            ],
          },
        ],
      },
    ],
    []
  );

  const closeModal = () => setSelected(null);

  return (
    <section className="servicesSection" id="allServices">
      <div className="container servicesWrap">
        <Fade>
          <h2 className="servicesTitle">Nuestros banquetes</h2>
          <p className="servicesSubtitle">
            Elige el estilo que más se adapte a tu evento. Da clic en{" "}
            <b>Ver detalle</b> para ver menú completo y precios.
          </p>
        </Fade>

        <div className="servicesGrid">
          {services.map((s) => (
            <Fade key={s.id} triggerOnce>
              <article className="serviceCard">
                <div className="serviceImg">
                  <img
                    src={s.image}
                    alt={`${s.title} - Pixbae Banquetes`}
                    loading="lazy"
                  />
                  {s.badge && <span className="badge">{s.badge}</span>}
                </div>

                <div className="serviceBody">
                  <h3 className="serviceName">{s.title}</h3>
                  <p className="serviceDesc">{s.short}</p>

                  <div className="serviceActions">
                    <button
                      className="btnDetails"
                      onClick={() => setSelected(s)}
                      aria-label={`Ver detalle de ${s.title}`}
                    >
                      Ver detalle
                    </button>

                    <Whats
                      classStyle="btnWhatsMini"
                      phoneNumber={WHATS_NUMBER}
                      message={`Hola, quiero cotizar el banquete: ${s.title}`}
                      text="WhatsApp"
                    />
                  </div>
                </div>
              </article>
            </Fade>
          ))}
        </div>
      </div>

      {/* MODAL */}
      {selected && (
        <div className="modalOverlay" role="dialog" aria-modal="true">
          <div className="modalCard">
            <button className="modalClose" onClick={closeModal} aria-label="Cerrar">
              ×
            </button>

            <div className="modalHeader">
              <h3 className="modalTitle">{selected.modalTitle}</h3>
              <p className="modalHint">
                Cotiza por WhatsApp y te respondemos con disponibilidad y propuesta.
              </p>
            </div>

            <div className="modalBody">
              {selected.blocks.map((b, idx) => (
                <div className="modalBlock" key={idx}>
                  <h4 className="modalBlockTitle">{b.heading}</h4>

                  {b.type === "text" && <p className="modalText">{b.text}</p>}

                  {b.type === "bullets" && (
                    <ul className="modalList">
                      {b.items.map((it, i) => (
                        <li key={i}>{it}</li>
                      ))}
                    </ul>
                  )}

                  {b.type === "numbered" && (
                    <ol className="modalList numbered">
                      {b.items.map((it, i) => (
                        <li key={i}>{it}</li>
                      ))}
                    </ol>
                  )}
                </div>
              ))}
            </div>

            <div className="modalFooter">
              <Whats
                classStyle="btnModalWhats"
                phoneNumber={WHATS_NUMBER}
                message={`Hola, quiero cotizar el banquete: ${selected.title}`}
                text="Cotizar por WhatsApp"
              />
            </div>
          </div>

          {/* click fuera cierra */}
          <button className="modalBackdrop" onClick={closeModal} aria-label="Cerrar modal" />
        </div>
      )}
    </section>
  );
};

export default Services;
